export const hvacQuickStartTemplates = [
  {
    id: 'builtin-hvac-system-replacement',
    name: 'HVAC System Replacement (Residential)',
    description: 'Starter quote for full system replacements with financing, rebates, and upgrade add-ons.',
    is_default: true,
    is_builtin: true,
    usage_count: 0,
    interactive_enabled: true,
    show_monthly_payments: true,
    financing_apr: 8.99,
    financing_term_months: 84,
    financing_down_payment: 0,
    rebates: [
      {
        label: 'Federal Energy Credit (Estimate)',
        amount_type: 'fixed',
        amount_value: 2000,
        notes: 'Subject to homeowner qualification and current IRS rules.'
      },
      {
        label: 'Utility Rebate (Estimate)',
        amount_type: 'fixed',
        amount_value: 1200,
        notes: 'Depends on utility program availability and equipment match.'
      }
    ],
    addons: [
      {
        label: 'Smart Thermostat Upgrade',
        unitPrice: 299,
        quantityMin: 0,
        quantityMax: 1,
        defaultQuantity: 1,
        tierLevel: 'all',
        isPreselected: false,
        displayOrder: 0
      },
      {
        label: 'UV Air Purifier',
        unitPrice: 599,
        quantityMin: 0,
        quantityMax: 2,
        defaultQuantity: 1,
        tierLevel: 'better',
        isPreselected: true,
        displayOrder: 1
      },
      {
        label: 'Media Filter Cabinet Upgrade',
        unitPrice: 450,
        quantityMin: 0,
        quantityMax: 1,
        defaultQuantity: 1,
        tierLevel: 'best',
        isPreselected: true,
        displayOrder: 2
      }
    ],
    equipment_metadata: {
      good: {
        modelOutdoor: 'XR14-048',
        modelIndoor: 'TEM6-4',
        modelFurnace: 'S8X1-C',
        ahriReference: '210998877',
        ahriCertificateUrl: '',
        seer2: '14.3',
        hspf2: '7.8',
        afue: '80'
      },
      better: {
        modelOutdoor: 'XR16-048',
        modelIndoor: 'TEM8-4',
        modelFurnace: 'S9V2-C',
        ahriReference: '211223344',
        ahriCertificateUrl: '',
        seer2: '16.2',
        hspf2: '8.9',
        afue: '96'
      },
      best: {
        modelOutdoor: 'XV20i-048',
        modelIndoor: 'TAMX-4',
        modelFurnace: 'XC95m-C',
        ahriReference: '211556677',
        ahriCertificateUrl: '',
        seer2: '20.1',
        hspf2: '9.8',
        afue: '97'
      }
    },
    good_title: 'Comfort 14',
    good_price: 8990,
    good_description: 'Reliable entry-level replacement for homeowners focused on upfront value.',
    good_bullet_points: [
      '14 SEER2 matched system',
      'Single-stage compressor',
      'New pad, whip, and disconnect',
      'Digital non-programmable thermostat',
      '10-year parts warranty registration included'
    ],
    better_title: 'Efficiency 16',
    better_price: 11990,
    better_description: 'Balanced efficiency and comfort for most homes.',
    better_bullet_points: [
      '16 SEER2 high-efficiency system',
      'Two-stage performance for steadier temps',
      'Smart thermostat with app control',
      'Improved humidity control profile',
      '10-year parts + 2-year labor warranty'
    ],
    best_title: 'Quiet Comfort 20',
    best_price: 15490,
    best_description: 'Premium low-noise, high-efficiency system with best long-term comfort.',
    best_bullet_points: [
      '20 SEER2 inverter platform',
      'Variable-speed blower and condenser',
      'Priority install crew and commissioning',
      'Advanced airflow balancing',
      '10-year parts + 10-year labor warranty'
    ]
  },
  {
    id: 'builtin-hvac-maintenance-iaq',
    name: 'HVAC Maintenance + IAQ Upgrade',
    description: 'Starter quote for service plans with optional indoor air quality and airflow upgrades.',
    is_default: false,
    is_builtin: true,
    usage_count: 0,
    interactive_enabled: true,
    show_monthly_payments: true,
    financing_apr: 0,
    financing_term_months: 12,
    financing_down_payment: 0,
    rebates: [
      {
        label: 'Manufacturer IAQ Promo (Estimate)',
        amount_type: 'fixed',
        amount_value: 200,
        notes: 'Limited-time promotions vary by distributor and model.'
      }
    ],
    addons: [
      {
        label: 'Duct Cleaning Package',
        unitPrice: 650,
        quantityMin: 0,
        quantityMax: 1,
        defaultQuantity: 1,
        tierLevel: 'all',
        isPreselected: false,
        displayOrder: 0
      },
      {
        label: 'Additional Return Air Grille',
        unitPrice: 275,
        quantityMin: 0,
        quantityMax: 4,
        defaultQuantity: 1,
        tierLevel: 'better',
        isPreselected: false,
        displayOrder: 1
      },
      {
        label: 'Whole-Home Surge Protection',
        unitPrice: 349,
        quantityMin: 0,
        quantityMax: 1,
        defaultQuantity: 1,
        tierLevel: 'best',
        isPreselected: true,
        displayOrder: 2
      }
    ],
    equipment_metadata: {
      good: {
        modelOutdoor: '',
        modelIndoor: '',
        modelFurnace: '',
        ahriReference: '',
        ahriCertificateUrl: '',
        seer2: '',
        hspf2: '',
        afue: ''
      },
      better: {
        modelOutdoor: '',
        modelIndoor: '',
        modelFurnace: '',
        ahriReference: '',
        ahriCertificateUrl: '',
        seer2: '',
        hspf2: '',
        afue: ''
      },
      best: {
        modelOutdoor: '',
        modelIndoor: '',
        modelFurnace: '',
        ahriReference: '',
        ahriCertificateUrl: '',
        seer2: '',
        hspf2: '',
        afue: ''
      }
    },
    good_title: 'Seasonal Tune-Up',
    good_price: 349,
    good_description: 'One-time inspection and performance tune-up.',
    good_bullet_points: [
      'Spring or fall system tune-up',
      'Electrical and safety inspection',
      'Static pressure spot-check',
      'Filter replacement reminder'
    ],
    better_title: 'Comfort Membership',
    better_price: 599,
    better_description: 'Annual plan with priority service and IAQ recommendations.',
    better_bullet_points: [
      'Two seasonal tune-ups per year',
      'Priority scheduling and reduced diagnostics',
      '5% discount on repairs',
      'Indoor air quality assessment report'
    ],
    best_title: 'Whole-Home Comfort+',
    best_price: 1099,
    best_description: 'Full-year plan with proactive airflow and IAQ optimization.',
    best_bullet_points: [
      'Everything in Comfort Membership',
      'Quarterly performance checks',
      'Filter delivery plan included',
      'Airflow balancing and duct leakage review',
      '10% discount on repairs and accessories'
    ]
  }
];
